// Update contents object below
const contents = {
  header: 'Lenovo + Intel', //update with your client name

  hero: {
    background: 'video', //options: "image" or "video"
    logoPlacement: 'top', //options: "top" or "center"
    title: '',
    copy: ''
  },
  inlinePhotos: {
    size: 'bodyWidth', //options: "fullBleed" or "bodyWidth"
    contents: [
      { class: 'photo1', caption: '© Island Conservation' },
      { class: 'photo2', caption: '© Callum Thompson, Lenovo Work For Humankind' },
      { class: 'photo3', caption: '© Callum Thompson, Lenovo Work For Humankind' },
      { class: 'photo4', caption: '' }
    ] //add more objects in the array if you have more than one photo
  },
  ctaTooltip: {
    href: 'https://www.courageousstudios.com/', //where the cta button click drives to
    copy: 'www.courageousstudios.com/' //tooltip content
  }
};

export default contents;
